<template>
  <v-container fluid>
    <v-row class="my-0 py-0" justify="center">
      <v-col sm="12" md="10">
        <v-sheet elevation="1">
          <v-row>
            <v-col sm="12" md="8" class="d-flex align-self-center">
              <v-avatar color="primary" class="mx-3 align-self-center">
                <v-icon dark>fas fa-cube</v-icon>
              </v-avatar>
              <div class="px-3">
                <b>{{ batch.forgeID }}</b>
                <div>
                  {{ batch.name }}
                </div>
              </div>
            </v-col>
            <v-col sm="12" md="4" class="align-self-center">
              <div class="d-flex justify-end pa-2">
                <v-btn
                  outlined
                  rounded
                  color="primary"
                  class="mx-2"
                  :to="{ name: 'BatchLabelView', params: { id: batch.project, batchid: batch.id } }"
                >
                  <v-icon left>print</v-icon>
                  Label
                </v-btn>
                <BatchStateChange :batch="batch" :minimal="false" />
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
    <v-container class="my-0 py-0">
      <v-row justify="center">
        <v-col sm="12" md="3">
          <v-row>
            <v-col sm="12">
              <BatchInfoCard :batch="batch" />
            </v-col>
            <v-col sm="12">
              <BaseAttachmentList :attachments="batch.attachments" :loading="false">
                <template #actions>
                  <BatchAttachmentForm :id="batch.id" />
                </template>
              </BaseAttachmentList>
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="12" md="7">
          <v-row>
            <v-col sm="12">
              <v-card>
                <v-card-title>
                  <v-icon left>fas fa-running</v-icon>
                  Run Notes
                  <v-spacer />
                  <BatchRunNotesEdit :batch="batch" />
                </v-card-title>
                <v-card-subtitle>Notes regarding the runs for this batch. Includes process deviations, re-works, etc.</v-card-subtitle>
                <v-card-text v-html="batch.runnotes" style="white-space: pre-wrap" class="black--text body-2"/>
              </v-card>
            </v-col>
            <v-col sm="12">
              <v-card>
                <v-card-title>
                  <v-icon left>fas fa-heartbeat</v-icon>
                  Quality Control Data
                </v-card-title>
                <QualityCoatedMeasurementTable
                  :batchid="batch.id"
                  :is-detailed="false"
                  :loading="false"
                  :measurements="batch.measurements"
                />
              </v-card>
            </v-col>
            <v-col sm="12">
              <v-card>
                <v-card-title>
                  <v-icon left>grain</v-icon>
                  Batch Composition
                  <v-spacer />
                  <BatchRawOriginForm
                    :is-edit="false"
                    :batchid="batch.id"
                    :materialid="batch.workorder.material_id"
                  />
                </v-card-title>
                <BatchRawOriginTable
                  :is-detailed="true"
                  :batchid="batch.id"
                  :loading="false"
                  :items="batch.composition"
                  :materialid="batch.workorder.material_id"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
// TODO Update all Composition, Measurement, Process Tables
// TODO Add batch history
// TODO Add tool assignment
import Batch from "../../models/Batch";
import BaseAttachmentList from "../../components/Attachments/BaseAttachmentList";
import BatchAttachmentForm from "../../components/Batch/BatchAttachmentForm";
import QualityCoatedMeasurementTable from "../../components/Quality/QualityCoatedMeasurementTable";
import BatchRawOriginTable from "../../components/Batch/BatchRawOriginTable";
import BatchInfoCard from "../../components/Batch/BatchInfoCard";
import BatchRawOriginForm from "../../components/Batch/BatchRawOriginNew";
import BatchStateChange from "../../components/Batch/BatchStateChange";
import BatchRunNotesEdit from "../../components/Batch/BatchRunNotesEdit";
export default {
  name: "BatchDetailView",
  components: {
    BatchRunNotesEdit,
    BatchStateChange,
    BatchRawOriginForm,
    BatchInfoCard,
    BatchRawOriginTable,
    QualityCoatedMeasurementTable,
    BatchAttachmentForm,
    BaseAttachmentList
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    batchid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    batch() {
      return Batch.query()
        .with("location")
        .with("parent")
        .with("children")
        .with("attachments")
        .with("measurements.batch")
        .with("composition.rawmaterial")
        .with("workorder.material")
        .find(parseInt(this.batchid))
    }
  }
}
</script>
